export default {
  API_URL: 'https://wieland-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://wielandsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
